import {
  APP_INITIALIZER,
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import {
  handleIntegrations,
  IntegrationsService,
} from './app/shared/util/integrations';
import { AppComponent } from './app/app.component';
import { ToastrModule } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appRoutingProviders } from './app/app-routing.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { DatePipe, DOCUMENT } from '@angular/common';
import { ErrorInterceptor } from './app/shared/api/error.interceptor';
import { AuthInterceptor } from './app/user/auth-interceptor';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { Router, RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './app/custom-route-reuse.strategy';
import { LoadingInterceptor } from './app/shared/api/loading.interceptor';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';
import { PageScrollLockStrategy } from './app/shared/services/page-scroll-lock';

function initIntegrations(svc: IntegrationsService) {
  return () => svc.initAll();
}

if (environment.production) {
  enableProdMode();
  handleIntegrations();
}
//@ts-ignore
bootstrapApplication(AppComponent, {
  providers: [
    IntegrationsService,
    appRoutingProviders,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(ToastrModule.forRoot()),
    DatePipe,
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initIntegrations,
      deps: [IntegrationsService],
      multi: true,
    },
    {
      // Every dialog freezes the page behind it with this instead of the CDK
      // default, which shifts the page (see PageScrollLockStrategy).
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: (document: Document) => () =>
        new PageScrollLockStrategy(document),
      deps: [DOCUMENT],
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  ],
}).catch((err) => console.error(err));
